function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2778 154.989H215.79C220.793 154.989 225.51 156.954 229.073 160.522C229.446 160.895 229.798 161.284 230.136 161.683C236.473 147.416 240 131.622 240 115C240 51.4872 188.583 0 125.156 0C61.7297 0 10.3125 51.4872 10.3125 115C10.3125 129.095 12.8498 142.596 17.4839 155.075C18.0769 155.019 18.6755 154.989 19.2778 154.989Z",
  fill: "#814BE0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.458 192.656C61.4538 215.605 91.6253 229.997 125.156 229.997C158.687 229.997 188.858 215.605 209.854 192.656H40.458Z",
  fill: "#6600C5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M135.279 19.8115C135.279 14.659 132.541 10.1496 128.444 7.65528C127.791 7.25817 126.953 7.73226 126.953 8.49689V19.3501C126.953 19.6782 126.789 19.9847 126.517 20.1668L121.619 23.43C121.29 23.6492 120.863 23.6492 120.534 23.43L115.636 20.1668C115.364 19.9852 115.2 19.6786 115.2 19.3501V8.49689C115.2 7.73226 114.362 7.25817 113.709 7.65528C109.613 10.1496 106.875 14.659 106.875 19.8115C106.875 25.2742 109.953 30.0141 114.465 32.3962C114.921 32.6366 115.2 33.1149 115.2 33.6307V74.7355C115.2 77.9855 117.832 80.6202 121.077 80.6202C124.323 80.6202 126.954 77.9855 126.954 74.7355V33.6307C126.954 33.1149 127.234 32.6366 127.689 32.3962C132.202 30.0141 135.279 25.2742 135.279 19.8115Z",
  fill: "#E8EDF2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M120.077 72.5071V63.125H115.947C115.695 63.125 115.447 63.14 115.2 63.163V74.7381C115.2 77.9882 117.831 80.6228 121.077 80.6228C122.948 80.6228 124.612 79.7437 125.688 78.3787C122.567 78.2383 120.077 75.6675 120.077 72.5071Z",
  fill: "#D9E7EC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M114.465 32.3995C114.921 32.6399 115.2 33.1182 115.2 33.634V49.0628C115.449 49.0544 115.697 49.0436 115.948 49.0436H120.078V31.403C120.078 30.8872 119.798 30.4089 119.342 30.1685C114.83 27.7869 111.752 23.0465 111.752 17.5838C111.752 14.0474 113.043 10.8138 115.177 8.32699C115.06 7.66938 114.311 7.29293 113.71 7.65858C109.613 10.1529 106.875 14.6623 106.875 19.8148C106.875 25.2775 109.953 30.0174 114.465 32.3995Z",
  fill: "#D9E7EC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M107.915 86.5891V71.1646C107.915 66.7293 111.518 63.1207 115.947 63.1207H123.9C127.783 63.1207 130.932 59.9683 130.932 56.0799C130.932 52.1915 127.783 49.0391 123.9 49.0391H115.947C103.764 49.0391 93.8521 58.9647 93.8521 71.1646V90.2091C98.3333 88.5169 103.04 87.2909 107.915 86.5891Z",
  fill: "#A2E62E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7257 88.0785V71.1646C98.7257 58.9647 108.637 49.0391 120.821 49.0391H115.948C103.764 49.0391 93.8525 58.9647 93.8525 71.1646V89.6904C95.4491 89.0933 97.0743 88.5549 98.7257 88.0785Z",
  fill: "#97D729"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M178.95 4.53906C156.324 4.53906 137.812 23.0757 137.812 45.7321V80.1105L138.765 80.5799H218.999L220.087 80.1105V45.7321C220.087 23.0757 201.575 4.53906 178.95 4.53906Z",
  fill: "#A2E62E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M157.726 80.1105V45.7321C157.726 26.5111 171.051 10.2576 188.906 5.7698C185.715 4.96761 182.38 4.53906 178.95 4.53906C156.324 4.53906 137.812 23.0757 137.812 45.7321V80.1105H157.726Z",
  fill: "#97D729"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M183.721 140.967L183.792 141.351H189.36C194.76 141.351 199.153 145.75 199.153 151.157V154.989H215.79C217.254 154.989 218.692 155.162 220.086 155.49V80.1094H137.812V89.0179C161.027 96.3521 179.104 115.975 183.721 140.967Z",
  fill: "#FE646F"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M176.348 119.538H176.948V80.1094H165.229V105.078C169.549 109.363 173.298 114.223 176.348 119.538Z",
  fill: "#FD4755"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2759 192.66C37.1392 198.009 42.2171 201.847 48.1937 201.847C54.1703 201.847 59.2482 198.008 61.1115 192.66H35.2759Z",
  fill: "#FED402"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2963 193.129H35.4502C37.441 198.231 42.3943 201.847 48.1946 201.847C49.9303 201.847 51.5888 201.52 53.1164 200.93C49.5389 199.547 46.6918 196.702 45.2963 193.129Z",
  fill: "#FAC600"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M174.026 192.66C175.889 198.009 180.967 201.847 186.944 201.847C192.92 201.847 197.998 198.008 199.862 192.66H174.026Z",
  fill: "#FED402"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M184.046 193.133H174.2C176.191 198.235 181.144 201.851 186.944 201.851C188.68 201.851 190.339 201.524 191.866 200.934C188.289 199.551 185.441 196.706 184.046 193.133Z",
  fill: "#FAC600"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M184.27 141.353C178.63 109.566 150.897 85.4297 117.534 85.4297C84.1714 85.4297 56.4383 109.566 50.7983 141.353H184.27Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M75.5669 140.883C80.6556 113.336 102.355 91.6247 129.875 86.5553C125.873 85.8179 121.75 85.4297 117.535 85.4297C84.3363 85.4297 56.7161 109.33 50.8872 140.883H75.5669V140.883Z",
  fill: "#E8EDF2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M199.621 154.99V151.158C199.621 145.483 195.027 140.883 189.36 140.883H45.7077C40.0405 140.883 35.4468 145.483 35.4468 151.158V154.99H199.621Z",
  fill: "#FED402"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6874 154.52V151.158C64.6874 145.483 69.2811 140.883 74.9483 140.883H45.7077C40.0405 140.883 35.4468 145.483 35.4468 151.158V154.52H64.6874Z",
  fill: "#FAC600"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M66.7871 192.66V195.977C66.7871 200.77 70.6669 204.654 75.4524 204.654H159.616C164.401 204.654 168.281 200.769 168.281 195.977V192.66H66.7871Z",
  fill: "#FED402"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M91.4063 195.977V193.129H66.7871V195.977C66.7871 200.769 70.6669 204.654 75.4524 204.654H100.072C95.2862 204.654 91.4063 200.769 91.4063 195.977Z",
  fill: "#FAC600"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M215.79 193.129H19.2783C8.67515 193.129 0 184.442 0 173.824C0 163.206 8.67515 154.52 19.2783 154.52H215.79C226.393 154.52 235.069 163.206 235.069 173.824C235.068 184.442 226.393 193.129 215.79 193.129Z",
  fill: "#FE9901"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M39.375 173.824C39.375 163.206 48.0501 154.52 58.6533 154.52H19.2783C8.67515 154.52 0 163.206 0 173.824C0 184.442 8.67515 193.129 19.2783 193.129H58.6533C48.0501 193.129 39.375 184.442 39.375 173.824Z",
  fill: "#FB8801"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M213.843 116.331H200.083C200.031 116.331 199.981 116.324 199.932 116.316V119.541H160.253C156.37 119.541 153.221 122.693 153.221 126.581C153.221 130.47 156.37 133.622 160.253 133.622H200.662C208.014 133.622 213.994 127.633 213.994 120.272V116.316C213.945 116.324 213.895 116.331 213.843 116.331Z",
  fill: "#A2E62E"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M205.409 128.771H165C161.117 128.771 157.969 125.618 157.969 121.73C157.969 121.073 158.065 120.44 158.234 119.836C155.335 120.705 153.222 123.393 153.222 126.579C153.222 130.467 156.37 133.62 160.253 133.62H200.662C205.612 133.62 209.938 130.902 212.237 126.881C210.239 128.08 207.903 128.771 205.409 128.771Z",
  fill: "#97D729"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M163.058 68.0724C162.931 68.0724 162.803 68.0559 162.678 68.0221L154.562 65.8446C150.927 64.8693 147.663 62.7439 145.472 59.6797C142.623 55.6937 141.747 50.8059 142.992 46.151C143.168 45.4948 143.761 45.0625 144.408 45.0625C144.534 45.0625 144.661 45.0789 144.788 45.1132L152.904 47.2907C156.539 48.2661 159.804 50.3919 161.994 53.4566C164.844 57.4421 165.72 62.3299 164.474 66.9848C164.373 67.3612 164.128 67.6818 163.791 67.8762C163.566 68.0057 163.313 68.0724 163.058 68.0724Z",
  fill: "#314DC9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M159.31 65.8456C155.675 64.8702 152.411 62.7448 150.22 59.6802C147.371 55.6946 146.495 50.8064 147.74 46.1515C147.761 46.0731 147.789 45.9985 147.821 45.9266L144.79 45.1132C144.662 45.0789 144.535 45.0625 144.409 45.0625C143.762 45.0625 143.17 45.4953 142.994 46.151C141.748 50.8059 142.625 55.6937 145.474 59.6797C147.664 62.7439 150.929 64.8697 154.564 65.8451L162.68 68.0226C162.804 68.0559 162.932 68.0728 163.059 68.0728C163.314 68.0728 163.568 68.0062 163.793 67.8762C164.06 67.7217 164.266 67.4861 164.392 67.2082L159.31 65.8456Z",
  fill: "#2740B0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M176.82 68.0719C176.947 68.0719 177.074 68.0555 177.2 68.0217L185.247 65.8625C189.362 64.7585 192.982 62.1797 195.165 58.517C197.402 54.7647 198.013 50.3624 196.885 46.151C196.709 45.4948 196.117 45.0625 195.47 45.0625C195.344 45.0625 195.216 45.0789 195.089 45.1132L187.042 47.2724C182.927 48.3764 179.307 50.9552 177.123 54.6188C174.887 58.3711 174.277 62.7734 175.404 66.9843C175.505 67.3608 175.75 67.6814 176.087 67.8757C176.312 68.0052 176.565 68.0719 176.82 68.0719Z",
  fill: "#314DC9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M180.466 66.9839C179.339 62.7725 179.95 58.3701 182.186 54.6183C184.369 50.9547 187.99 48.3759 192.105 47.2719L196.833 46.0036C196.613 45.4324 196.067 45.0625 195.47 45.0625C195.345 45.0625 195.217 45.0789 195.09 45.1132L187.043 47.2724C182.928 48.3764 179.307 50.9552 177.124 54.6188C174.888 58.3711 174.277 62.7734 175.404 66.9843C175.505 67.3608 175.751 67.6809 176.087 67.8757C176.312 68.0057 176.565 68.0724 176.82 68.0724C176.947 68.0724 177.075 68.0559 177.199 68.0221L180.521 67.1308C180.502 67.0815 180.48 67.0345 180.466 66.9839Z",
  fill: "#2740B0"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M157.993 36.6277C161.146 36.6277 163.701 34.0685 163.701 30.9115C163.701 27.7545 161.146 25.1953 157.993 25.1953C154.84 25.1953 152.284 27.7545 152.284 30.9115C152.284 34.0685 154.84 36.6277 157.993 36.6277Z",
  fill: "#D1F19E"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M185.013 36.6277C188.166 36.6277 190.722 34.0685 190.722 30.9115C190.722 27.7545 188.166 25.1953 185.013 25.1953C181.86 25.1953 179.305 27.7545 179.305 30.9115C179.305 34.0685 181.86 36.6277 185.013 36.6277Z",
  fill: "#D1F19E"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M171.587 49.7371C174.739 49.7371 177.295 47.1779 177.295 44.0209C177.295 40.8639 174.739 38.3047 171.587 38.3047C168.434 38.3047 165.878 40.8639 165.878 44.0209C165.878 47.1779 168.434 49.7371 171.587 49.7371Z",
  fill: "#D1F19E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M215.25 115.391V93.3199C215.25 88.6687 211.449 84.7188 206.805 84.8061C202.301 84.8906 198.676 88.5725 198.676 93.1025V115.391C198.676 116.169 199.306 116.8 200.082 116.8H213.843C214.62 116.8 215.25 116.169 215.25 115.391Z",
  fill: "#FD4755"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M205.614 115.391V93.1021C205.614 89.7788 207.569 86.9179 210.387 85.5933C209.297 85.0737 208.085 84.7817 206.805 84.8061C202.302 84.8906 198.677 88.5725 198.677 93.1025V115.391C198.677 116.169 199.306 116.8 200.083 116.8H207.02C206.244 116.799 205.614 116.169 205.614 115.391Z",
  fill: "#FB2B3A"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M149.357 177.426H85.7105C82.2765 177.426 79.4668 174.613 79.4668 171.174C79.4668 167.735 82.2765 164.922 85.7105 164.922H149.357C152.791 164.922 155.601 167.735 155.601 171.174C155.601 174.613 152.791 177.426 149.357 177.426Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M108.75 171.174C108.75 167.735 111.559 164.922 114.993 164.922H85.7105C82.2765 164.922 79.4668 167.735 79.4668 171.174C79.4668 174.613 82.2765 177.426 85.7105 177.426H114.993C111.559 177.426 108.75 174.613 108.75 171.174Z",
  fill: "#E8EDF2"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M62.7133 92.0866C60.8791 92.8574 59.9182 93.8196 59.1485 95.6563C58.8311 96.4139 57.7465 96.4139 57.4286 95.6563C56.659 93.8196 55.698 92.8574 53.8638 92.0866C53.1072 91.7689 53.1072 90.6827 53.8638 90.3644C55.698 89.5937 56.659 88.6315 57.4286 86.7948C57.746 86.0372 58.8307 86.0372 59.1485 86.7948C59.9182 88.6315 60.8791 89.5937 62.7133 90.3644C63.4704 90.6827 63.4704 91.7684 62.7133 92.0866Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2133 39.9851C83.3791 40.7558 82.4182 41.718 81.6485 43.5548C81.3311 44.3124 80.2465 44.3124 79.9286 43.5548C79.159 41.718 78.198 40.7558 76.3638 39.9851C75.6072 39.6673 75.6072 38.5811 76.3638 38.2629C78.198 37.4922 79.159 36.5299 79.9286 34.6932C80.246 33.9356 81.3307 33.9356 81.6485 34.6932C82.4182 36.5299 83.3791 37.4922 85.2133 38.2629C85.9704 38.5811 85.9704 39.6668 85.2133 39.9851Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6674 66.4109C48.8332 67.1816 47.8723 68.1438 47.1026 69.9805C46.7853 70.7381 45.7006 70.7381 45.3828 69.9805C44.6131 68.1438 43.6521 67.1816 41.8179 66.4109C41.0613 66.0931 41.0613 65.0069 41.8179 64.6887C43.6521 63.9179 44.6131 62.9557 45.3828 61.119C45.7001 60.3614 46.7848 60.3614 47.1026 61.119C47.8723 62.9557 48.8332 63.9179 50.6674 64.6887C51.4245 65.0069 51.4245 66.0926 50.6674 66.4109Z",
  fill: "#FED402"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6674 124.942C33.8332 125.713 32.8723 126.675 32.1026 128.512C31.7853 129.269 30.7006 129.269 30.3828 128.512C29.6131 126.675 28.6521 125.713 26.8179 124.942C26.0613 124.624 26.0613 123.538 26.8179 123.22C28.6521 122.449 29.6131 121.487 30.3828 119.65C30.7001 118.893 31.7848 118.893 32.1026 119.65C32.8723 121.487 33.8332 122.449 35.6674 123.22C36.4245 123.538 36.4245 124.624 35.6674 124.942Z",
  fill: "#FED402"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M233.948 121.329C232.114 122.1 231.153 123.062 230.384 124.899C230.066 125.656 228.982 125.656 228.664 124.899C227.894 123.062 226.933 122.1 225.099 121.329C224.342 121.011 224.342 119.925 225.099 119.607C226.933 118.836 227.894 117.874 228.664 116.037C228.981 115.279 230.066 115.279 230.384 116.037C231.153 117.874 232.114 118.836 233.948 119.607C234.705 119.925 234.705 121.011 233.948 121.329Z",
  fill: "#FED402"
});

var SvgIcTester = function SvgIcTester(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 230,
    viewBox: "0 0 240 230",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTester, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tester.1a27c587.svg";
export { ForwardRef as ReactComponent };